import React, { useState } from "react";

import Page from "components/Page";
import {SelectGoals, SelectIndicator} from "components/Select";
import Files from "features/UploadFiles";

import { i18n } from 'translate/i18n'
import {useParams} from "react-router";

const Upload = () => {

    const {param} = useParams();

    const [selectedIndicator, setSelectedIndicator] = useState(null);
    const [selectedGoals, setSelectedGoal] = useState(null);

    return (
        <Page
            label={param === 'indicators' ? i18n.t('titlePage.indicators') : i18n.t('titlePage.goals')}
            icon="bi bi-cloud-upload"
        >
            <div className="card my-3 border-0 shadow-sm">
                <div className="card-body">
                    {param === 'indicators'
                        ? <SelectIndicator handleOnChange={(e) => { setSelectedIndicator(e) }} selected={selectedIndicator}/>
                        : <SelectGoals handleOnChange={(e) => { setSelectedGoal(e) }} selected={selectedGoals}/>
                    }
                </div>
            </div>
            <Files
                types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                param={param}
                selectedIndicator={selectedIndicator?.title}
                selectedGoal={selectedGoals?.title}
            />
        </Page>
    );
}

export default Upload
